// import http from './../../../base/api/public'
// let service = require('@/../config/serviceList')
// let sysConfig = require('@/../config/sysConfig')
// let apiPre = sysConfig.apiPre
// service.res = ''
// export default {
//   getCards (params) {
//     console.log('params:' + JSON.stringify(params))
//     return http.requestPost(apiPre + service.res + '/card/getList', params)
//   }
// }
// 导入基本公共资源
import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
export default {
  // 费率
  getRates(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/rate/getRates', params)
  },
  getTimeSharing(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/timeSharing/getTimeSharing', params)
  },
  deleteRate(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/rate/deleteRate', params)
  },
  getOperatorsTree(params){
    return http.requestPost(apiPre + service.member + '/member/operator/listForSelectTree', params)
  },
  saveOrUpdateRate(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPut(apiPre + service.res + '/res/rate/saveOrUpdateRate', params)
  },
  getRateById(id) {
    return http.requestPost(apiPre + service.res + '/res/rate/getRateById/' + id, {})
  },
  saveRate(params){
    console.log('params'+JSON.stringify(params))
    return http.requestPut(apiPre+service.res+'/res/rate/saveRate',params)
  },
  editRate(params){
    console.log('params'+JSON.stringify(params))
    return http.requestPut(apiPre+service.res+'/res/rate/editRate',params)
  },
  getHisRates(params){
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/rate/getHisRates', params)
  }
}



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/rateApi.js